import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import EmailName from 'automation-ui-references/customer-data/EmailName';
import UserName from 'automation-ui-references/customer-data/UserName';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import * as ObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import SlackChannelName from 'automation-ui-references/reference-resolvers/SlackChannelName';
import SlackUserName from 'automation-ui-references/reference-resolvers/SlackUserName';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import AssociatedEntityTypes from 'automation-ui-log-events/records/ExecutionResult/AssociatedEntityTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ExecutionActionName = ({
  actionType,
  entityId,
  entityType,
  fullEmailAddress,
  objectTypeId
}) => {
  switch (actionType) {
    case ActionTypes.SET_PROPERTY:
    case ActionTypes.AUTOMATION_EXTENSION:
      return /*#__PURE__*/_jsx(ObjectNameReference, {
        id: entityId,
        objectTypeId: objectTypeId
      });
    case ActionTypes.SLACK_NOTIFICATION:
      {
        if (entityType === AssociatedEntityTypes.SLACK_USER) {
          return /*#__PURE__*/_jsx(SlackUserName, {
            id: entityId
          });
        } else if (entityType === AssociatedEntityTypes.SLACK_CHANNEL) {
          return /*#__PURE__*/_jsx(SlackChannelName, {
            id: entityId
          });
        } else {
          return /*#__PURE__*/_jsx(PropertyName, {
            objectTypeId: objectTypeId,
            propertyName: entityId
          });
        }
      }
    case ActionTypes.EMAIL:
      return /*#__PURE__*/_jsx(ObjectNameReference, {
        id: entityId,
        objectTypeId: ObjectTypes.CONTACT_ID
      });
    case ActionTypes.EMAIL_NOTIFICATION:
    case ActionTypes.IN_APP_NOTIFICATION:
      {
        if (entityType === AssociatedEntityTypes.NOTIFICATION_EMAIL_RECIPIENT) {
          return /*#__PURE__*/_jsx(EmailName, {
            id: entityId
          });
        }
        return /*#__PURE__*/_jsx(UserName, {
          id: entityId
        });
      }
    case ActionTypes.CLASSIC_NOTIFICATION_EMAIL:
      {
        if (fullEmailAddress) {
          return /*#__PURE__*/_jsx("span", {
            children: fullEmailAddress
          });
        }
        return /*#__PURE__*/_jsx(UserName, {
          id: entityId
        });
      }
    default:
      return /*#__PURE__*/_jsx(UserName, {
        id: entityId
      });
  }
};
export default ExecutionActionName;